// import tapestrySmall from "./patterns-small/tapestry-small.jpg";
// import polygon from "./patterns/polygon.jpg";
// import polygonSmall from "./patterns-small/polygon-small.jpg";
// import burlesque from "./patterns/burlesque.jpg";
// import burlesqueSmall from "./patterns-small/burlesque-small.jpg";
import fatalChoiceSmall from "./patterns-small/fatal-choice-small.jpg";
import feedTheBirdsSmall from "./patterns-small/feed-the-birds-small.jpg";
import grandmasHouseSmall from "./patterns-small/grandmas-house-small.jpg";
import headsSmall from "./patterns-small/heads-small.jpg";
import periwinkleBlueSmall from "./patterns-small/periwinkle-blue-small.jpg";
import redStarSmall from "./patterns-small/red-star-small.jpg";
import sometimesIfeelLowSmall from "./patterns-small/sometimes-i-feel-low-small.jpg";
import soundOfMuSmall from "./patterns-small/sound-of-mu-small.jpg";
import strawberryFieldsSmall from "./patterns-small/strawberry-fields-small.jpg";
import theValleyOfOblivionSmall from "./patterns-small/the-valley-of-oblivion-small.jpg";
import underTheSurfaceSmall from "./patterns-small/under-the-surface-small.jpg";
import whiteSatinSmall from "./patterns-small/white-satin-small.jpg";
import fatalChoice from "./patterns/fatal-choice.jpg";
import feedTheBirds from "./patterns/feed-the-birds.jpg";
import grandmasHouse from "./patterns/grandmas-house.jpg";
import heads from "./patterns/heads.jpg";
import periwinkleBlue from "./patterns/periwinkle-blue.jpg";
import redStar from "./patterns/red-star.jpg";
import sometimesIfeelLow from "./patterns/sometimes-i-feel-low.jpg";
import soundOfMu from "./patterns/sound-of-mu.jpg";
import strawberryFields from "./patterns/strawberry-fields.jpg";
import tapestry from "./patterns/tapestry.jpg";
import theValleyOfOblivion from "./patterns/the-valley-of-oblivion.jpg";
import underTheSurface from "./patterns/under-the-surface.jpg";
import whiteSatin from "./patterns/white-satin.jpg";

export const patterns = [
  {
    title: "Feed the Birds",
    date: "2014",
    size: "105x41",
    imageUrl: feedTheBirds,
    imageUrlSmall: feedTheBirdsSmall,
    sold: true,
  },
  {
    title: "Strawberry Fields",
    date: "2018",
    size: "105x41",
    imageUrl: strawberryFields,
    imageUrlSmall: strawberryFieldsSmall,
    sold: true,
  },
  {
    title: "Heads",
    date: "2017",
    size: "105x41",
    imageUrl: heads,
    imageUrlSmall: headsSmall,
    sold: true,
  },
  {
    title: "Grandma's House",
    date: "2013",
    size: "145x41",
    imageUrl: grandmasHouse,
    imageUrlSmall: grandmasHouseSmall,
    sold: true,
  },
  {
    title: "Tapestry",
    date: "2012",
    size: "145x41",
    // Something was wrong with the size of tapestrySmall
    imageUrl: tapestry,
    imageUrlSmall: tapestry,
    sold: true,
  },
  {
    title: "Sound of Mu...",
    date: "2016",
    size: "145x41",
    imageUrl: soundOfMu,
    imageUrlSmall: soundOfMuSmall,
    gifted: true,
  },
  {
    title: "The Valley of Oblivion",
    date: "2009",
    size: "145x145",
    imageUrl: theValleyOfOblivion,
    imageUrlSmall: theValleyOfOblivionSmall,
    gifted: true,
  },
  {
    title: "White Satin",
    date: "2021",
    size: "100x100",
    imageUrl: whiteSatin,
    imageUrlSmall: whiteSatinSmall,
  },
  {
    title: "Periwinkle Blue",
    date: "2009",
    size: "145x145",
    imageUrl: periwinkleBlue,
    imageUrlSmall: periwinkleBlueSmall,
  },
  // {
  //   title: "Burlesque",
  //   date: "2016",
  //   size: "130x105",
  //   imageUrl: burlesque,
  //   imageUrlSmall: burlesqueSmall,
  // },
  // {
  //   title: "Polygon",
  //   date: "2016",
  //   size: "130x105",
  //   imageUrl: polygon,
  //   imageUrlSmall: polygonSmall,
  // },
  {
    title: "Fatal Choice",
    date: "2016",
    size: "130x105",
    imageUrl: fatalChoice,
    imageUrlSmall: fatalChoiceSmall,
  },
  {
    title: "Red Star",
    date: "2017",
    size: "130x105",
    imageUrl: redStar,
    imageUrlSmall: redStarSmall,
  },
  {
    title: "Under the Surface",
    date: "2021",
    size: "130x105",
    imageUrl: underTheSurface,
    imageUrlSmall: underTheSurfaceSmall,
  },
  {
    title: "Sometimes I Feel Low",
    date: "2017",
    size: "130x105",
    imageUrl: sometimesIfeelLow,
    imageUrlSmall: sometimesIfeelLowSmall,
  },
];
